import { Link } from "react-router-dom";
import React from "react";

export default class PopularProducts extends React.Component {
  render() {
    const { popularItems } = this.props;

    return (
      <div className={` ${"popularItems"}`}>
        <div className={"popularItemsBoard"}>
          <span> {popularItems[0]?.cat_name} های پر بازدید</span>
          <div className={"items"}>
            {popularItems.slice(0, 4).map((item, index) =>
              item?.cat_id === 3 ? (
                <Link key={index} href={`product/${item.id}`}>
                  <img src={item.pic} />
                </Link>
              ) : (
                <></>
              )
            )}
          </div>
          <Link href={`/categories/${popularItems[0]?.cat_id}`}>
            <a>مشاهده همه</a>
          </Link>{" "}
        </div>
        <div className={"popularItemsBoard"}>
          <span>{popularItems[5]?.cat_name} های پر بازدید</span>
          <div className={"items"}>
            {popularItems.slice(4, 8).map((item, index) => (
              <Link key={index} href={`product/${item.slug}`}>
                <img src={item.pic} />
              </Link>
            ))}
          </div>
          <Link href={`/categories/${popularItems[5]?.cat_id}`}>
            <a>مشاهده همه</a>
          </Link>{" "}
        </div>
        <div className={"popularItemsBoard"}>
          <span>{popularItems[11]?.cat_name} های پر بازدید</span>
          <div className={"items"}>
            {popularItems.slice(8, 12).map((item, index) => (
              <Link key={index} href={`product/${item.id}`}>
                <img src={item.pic} />
              </Link>
            ))}
          </div>
          <Link href={`/categories/${popularItems[5]?.cat_id}`}>
            <a>مشاهده همه</a>
          </Link>
        </div>
      </div>
    );
  }
}
